"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eligibilityRuleSetFactory = exports.waiverRuleFactory = exports.ssdRuleFactory = exports.safesportRuleFactory = exports.proofOfBirthRuleFactory = exports.backgroundScreenRuleFactory = exports.apsRuleFactory = exports.membershipRuleFactory = exports.eligibilityRuleFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const util_1 = require("../../util");
exports.eligibilityRuleFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    display_name: 'Test',
    originator_system: null,
    originator_type: null,
    originator_id: Factory.each(i => uuid_1.v4()),
    linked_eligibility_rule_set_id: null,
    trigger: false,
});
exports.membershipRuleFactory = exports.eligibilityRuleFactory.extend({
    display_name: 'Test Membership',
    originator_system: util_1.services.MembershipService,
    originator_type: util_1.resources.membership_definition,
    trigger: true,
});
exports.apsRuleFactory = exports.eligibilityRuleFactory.extend({
    display_name: 'Test Aps',
    originator_system: util_1.services.SeApsService,
    originator_type: util_1.resources.aps,
    originator_id: 'aps',
});
exports.backgroundScreenRuleFactory = exports.eligibilityRuleFactory.extend({
    display_name: 'Test BackgroundScreen',
    originator_system: util_1.services.Ngin,
    originator_type: util_1.resources.background_screen,
    originator_id: Factory.each(i => i + 1),
});
exports.proofOfBirthRuleFactory = exports.eligibilityRuleFactory.extend({
    display_name: 'Test Proof Of Birth',
    originator_system: util_1.services.ProofOfBirthService,
    originator_type: util_1.resources.proof_of_birth,
    originator_id: '530',
});
exports.safesportRuleFactory = exports.eligibilityRuleFactory.extend({
    display_name: 'Test Safesport',
    originator_system: 'SeSafesportService',
    originator_type: 'safesport',
    originator_id: 'safesport',
});
exports.ssdRuleFactory = exports.eligibilityRuleFactory.extend({
    display_name: 'Test Sideline Sports',
    originator_system: 'SeSsdIntegrationService',
    originator_type: 'sideline_sports',
    originator_id: 'sideline_sports',
});
exports.waiverRuleFactory = exports.eligibilityRuleFactory.extend({
    display_name: 'Test Waiver',
    originator_system: 'MembershipService',
    originator_type: 'waiver',
});
exports.eligibilityRuleSetFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    name: 'Test Rule Set',
    boss_organization_id: 530,
    created_at: '2000-01-01T00:00:00.000Z',
    updated_at: '2000-01-01T00:00:00.000Z',
    eligibility_rules: [
        exports.membershipRuleFactory.build(),
        exports.apsRuleFactory.build(),
        exports.backgroundScreenRuleFactory.build(),
        exports.proofOfBirthRuleFactory.build(),
        exports.safesportRuleFactory.build(),
        exports.ssdRuleFactory.build(),
        exports.waiverRuleFactory.build(),
    ]
});
